export default {
  smallResolutionLabel: {
    display: 'inline-block',
    letterSpacing: '.08rem',
    lineHeight: '1.3rem',
    fontSize: '1.1rem',
    textAlign: 'center',
    paddingTop: '.3rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/ResolutionContainer/ModelResolutionDisplay/style.js